
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import { Container } from "inversify";
import { OrganizationStore } from "../../../stores/organization/OrganizationStore";
import LoadingOverlay from "../../../../../common/src/components/LoadingOverlay.vue";
import { OrganizationItem } from "@gsx/common/src/types/http/dashboard/organization";
import { AuthStore } from "../../../../../common/src/stores/AuthStore";
import { OrganizationProjectsCollectionStore } from "../../../stores/organization/resource/OrganizationProjectsCollectionStore";
import { handleError } from "../../../../../common/src/utility/errorUtils";
import SubscriptionUpgrade from "./SubscriptionUpgrade.vue";

@Component({
    components: {
        LoadingOverlay,
        SubscriptionUpgrade,
    },
})
export default class ProjectsPartners extends Vue {
    @Inject("container") readonly container!: Container;
    readonly organizationStore: OrganizationStore = this.container.get(OrganizationStore);
    readonly organizationProjects: OrganizationProjectsCollectionStore = this.container.get(
        OrganizationProjectsCollectionStore,
    );
    readonly authStore: AuthStore = this.container.get(AuthStore);

    mounted() {
        this.load();
    }

    get organizationId(): string {
        return this.$route.params.organization;
    }

    get organization(): OrganizationItem | null {
        return this.organizationStore.item;
    }

    @Watch("organizationId")
    load() {
        this.organizationProjects.load(this.organizationId).catch(handleError);
    }
}
